import { spore } from '@/spore/runtime';
import { Panel } from './Panel';

const ROLES = [
  ['mushroom', 'Mushroom', 'var(--spore)'],
  ['light', 'Light sensor', 'var(--amber)'],
  ['ignore', 'Ignore', 'var(--muted)'],
];

const ChannelCard = ({ c }) => {
  const active = c.ago < 0.6;
  return (
    <div data-testid={`channel-card-${c.channel}`} data-role={c.role} className="min-w-[260px] border border-[var(--hair)] p-4">
      <div className="flex items-center justify-between">
        <span className="font-display text-2xl font-bold">Ch {c.channel}</span>
        <span data-testid={`channel-activity-${c.channel}`} className={`flex items-center gap-2 text-sm ${active ? 'glow-spore' : 'text-[var(--muted)]'}`}>
          <span className={`dot-live ${active ? 'dot-pulse' : ''}`} style={{ background: active ? 'var(--spore)' : 'var(--dim)' }} />
          {active ? 'active now' : `last seen ${c.ago.toFixed(0)}s ago`}
        </span>
      </div>
      <div className="mt-1 text-xs text-[var(--muted)]">{c.count} events · last {c.lastType}</div>
      <div className="mt-3 flex gap-2">
        {ROLES.map(([role, label, color]) => (
          <button key={role} data-testid={`channel-role-${c.channel}-${role}`} className={`btn-lab px-2.5 py-1.5 text-[0.65rem] ${c.role === role ? 'active' : ''}`} style={c.role === role ? { color, borderColor: color } : undefined} onClick={() => spore.setChannelRole(c.channel, role)}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export const ChannelsPanel = ({ channels }) => (
  <Panel testId="channels-panel" code="00 / CHANNELS" title="MIDI Channels · Roles" right={<span className="text-xs text-[var(--muted)]">Only “Mushroom” channels affect mood, pulses and unlocks</span>}>
    <div className="flex flex-wrap gap-4">
      {channels.length ? (
        [...channels].sort((a, b) => a.channel - b.channel).map((c) => <ChannelCard key={c.channel} c={c} />)
      ) : (
        <p data-testid="channels-empty" className="text-sm text-[var(--dim)]">No MIDI events yet. Connect the Biotron and touch the specimen (or enable the simulator) — every channel that sends data appears here.</p>
      )}
    </div>
  </Panel>
);
